import { css } from "styled-system/css";

export const NotFoundPage = () => (
  <div className={css({ p: "8" })}>
    <p>Not found!</p>
  </div>
);
